import React, { createContext, useState, useEffect, useContext } from "react";
import { EDUCATION_LINK, SKILLS_LINK, SUMMARY_LINK, WORKHISTORY_LINK } from "../constants/constants";
import _ from "lodash";
import axios from "axios";

const ResumeContext = createContext({});

export const ResumeProvider = (props) => {
    const [showPreview, setShowPreview] = useState(false);
    const [generalPhrases, setGeneralPhrases] = useState(null);
    const [headingPhrases, setHeadingPhrases] = useState(null);
    const [workHistoryPhrases, setWorkHistoryPhrases] = useState(null);
    const [eductionHistoryPhrases, setEductionHistoryPhrases] = useState(null);
    const [skillPhrases, setSkillPhrases] = useState(null);
   //check all shared props + container for below files
    // wp-content/themes/resumebuilder/builder/src/initial-data.jsx
    // wp-content/themes/resumebuilder/builder/src/containers/EditorContainer.jsx
    // const resume = props.resume
    // const handlers = props.handlers
    // const { 
    //     resume, 
    //     handlers, 
    //     next_label,
    //     next_clicked,
    //     back_clicked,
    //     skip_clicked,
    //     skip_label,
    //     unskip_clicked,
    //     redirect_to,
    //     loginHash,
    //     user,
    //     job_category,
    // } = props
    const toggleSkip = name => {
        console.log('toggleee skip')
        let skipped_sections_temp = props.resume.skipped_sections == undefined ? [] : props.resume.skipped_sections;
        if(!props.resume.skipped_sections?.includes(name)){//Add to skip list
            skipped_sections_temp.push(name)
            props.handlers.updateResumePreview(
                { skipped_sections: [...skipped_sections_temp] },true
             )
             props.handlers.nuteralizeNextClick({skip_label: 'Add'});
            gaTrack('RT App', `Editor`, `Skip: ${name}`);
            let ga_cat = 'app_editor_skip_' + (name).replace(' ', '_');
            ga4Track(ga_cat, 'RT App', `Skip: ${name}`);
            return true
        }else { // undo skip
            //skipped_sections_temp.pop(name)
            const index = skipped_sections_temp.indexOf(name);
            if(index > -1){ // only splice array when item is found
                skipped_sections_temp.splice(index, 1); // 2nd parameter means remove one item only
            }
            props.handlers.updateResumePreview(
                { skipped_sections: [...skipped_sections_temp] },true
             )
             props.handlers.nuteralizeNextClick({skip_label: 'Skip'});
            return false
        }
    }

    const toggleProfilePicture = () => {
        // const { resume } = props;
        // delete resume.heading.profile_picture.picture_path;
        // delete resume.heading.profile_picture.picture_abs_path;
        // props.handlers.updateResumePreview(
        //     {
        //         ...props.resume,
        //         resume: resume
        //     }
        // );

        let show_profile_picture_tmp = (
            !props.resume.heading?.show_profile_picture 
            ? true 
            : props.resume.heading.show_profile_picture
        );
    
        show_profile_picture_tmp = (
            (!props.resume.heading.show_profile_picture 
            || props.resume.heading.show_profile_picture == undefined)
            ? true
            : false
        );

        props.handlers.updateResumePreview(
            {
                heading: {
                    ...props.resume.heading, 
                    show_profile_picture: show_profile_picture_tmp
                }
            }, true
        );

        return show_profile_picture_tmp;
    }

    const removeProfilePicture = () => {
        props.handlers.updateResumePreview(
            {
                heading: {
                    ...props.resume.heading, 
                    show_profile_picture: false,
                    profile_picture:{}
                }
            }, true
        );
    }

    const getGeneralPhrases = () => {
        return new Promise((resolve, reject) => {
            if(generalPhrases != null){
                resolve([...generalPhrases])
            }else{
                axios.get('/assets/data/phrases-general.json')
                .then(response => {
                    const res = response.data
                    setGeneralPhrases([...res])
                    resolve([...res])
                })
            }
        });
    }

    const getHeadingPhrases = () => {
        return new Promise((resolve, reject) => {
            if(headingPhrases != null){
                resolve([...headingPhrases])
            }else{
                axios.get('/assets/data/phrases-heading.json')
                .then(response => {
                    const res = response.data
                    setHeadingPhrases([...res])
                    resolve([...res])
                })
            }
        });
    }

    const getWorkHistoryPhrases = () => {
        return new Promise((resolve, reject) => {
            if(workHistoryPhrases != null){
                resolve([...workHistoryPhrases])
            }else{
                axios.get('/assets/data/phrases-work-history.json')
                .then(response => {
                    const res = response.data
                    setWorkHistoryPhrases([...res]);
                    resolve([...res])
                })
            }
        });
    }

    const getEducationHistoryPhrases = () => {
        return new Promise((resolve, reject) => {
            if(eductionHistoryPhrases != null){
                resolve([...eductionHistoryPhrases])
            }else{
                axios.get('/assets/data/phrases-education.json')
                .then(response => {
                    const res = response.data
                    setEductionHistoryPhrases([...res])
                    resolve([...res])
                })
            }
        });
    }

    const getSkillsPhrases = () => {
        return new Promise((resolve, reject) => {
            if(skillPhrases != null){
                resolve([...skillPhrases])
            }else{
                axios.get('/assets/data/phrases-skills.json')
                .then(response => {
                    const res = response.data
                    setSkillPhrases([...res])
                    resolve([...res])
                })
            }
        });
    }

    const fetchPhrases = () => {
        getGeneralPhrases();
        getHeadingPhrases();
        getWorkHistoryPhrases();
        getEducationHistoryPhrases();
        getSkillsPhrases();
    }

    const getDefaultPhrases = (section = '', callback = false) => {
        if(section == '') return
        switch(section){
            case 'heading':
            case 'work_history':
            case 'skills':
                getGeneralPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            case 'education_history':
                getEducationHistoryPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            default:
                //do nothing..
                break;
        }
    }

    const getPhrases = (section = '', callback = false) => {
        if(section == '') return
        switch(section){
            case 'heading':
                getHeadingPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            case 'work_history':
                getWorkHistoryPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            case 'education_history':
                getEducationHistoryPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            case 'skills':
                getSkillsPhrases().then(res => {
                    if(typeof callback == 'function') callback(res);
                });
                break;
            default:
                //do nothing..
                break;
        }
    }

    useEffect(() => {
        //on page load, phrases will be set from JSON file
        fetchPhrases();
    }, []);

    // const skipLabel = () => {
    //     if([WORKHISTORY_LINK, EDUCATION_LINK, SKILLS_LINK, SUMMARY_LINK].includes(location.pathname)){

    //     }
    // }

    return (
        <ResumeContext.Provider value={{...props, toggleSkip, toggleProfilePicture, removeProfilePicture, showPreview, setShowPreview, getDefaultPhrases, getPhrases}}>
            {props.children}
        </ResumeContext.Provider>)
}//
//export default ResumeContext;
export const useResume = () => {
    const context = useContext(ResumeContext);
    return context;
}
